<template>
  <v-card>
    <v-card-title class="py-0" style="height: 64px">
      <v-layout align-center class="pl-2" justify-start row>
        <v-flex xs5>
          <!--<v-btn @click="testdata">show data</v-btn>-->
          <span class="title">{{title}}</span>
          <span class="body-2 ml-4 grey--text"> {{params.type}}</span>
          <span class="body-2 ml-4 grey--text"> {{subtitle}}</span>
        </v-flex>
        <v-flex v-if="canUsePeriodDay || canUsePeriodWeek" xs2>
          <v-switch
            :disabled="!canUsePeriodDay && !canUsePeriodWeek"
            class="ml-4"
            false-value="sectional"
            label="循环"
            true-value="periodic"
            v-model="newRule.ruleType"
          ></v-switch>
        </v-flex>
        <v-flex xs4>
          <v-radio-group :disabled="!canUsePeriodWeek || !canUsePeriodDay" row v-if="isPeriod" v-model="newRule.period">
            <v-radio label="按天循环" value="day"></v-radio>
            <v-radio label="按周循环" value="week"></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text style="height: 500px">
      <v-container class="pt-0" grid-list-md>
        <v-form ref="form" v-model="valid">
          <!--起止日期-->
          <slot :newItem="newRule" :status="status" name="append"></slot>
          <v-subheader class="px-0">规则起止时间</v-subheader>
          <v-layout class="mb-4" row wrap>
            <v-flex lg6 md6 xs12>
              <l-select-datetime
                :max-date="maxStartDate"
                :min-date="minStartDate"
                :rules="[$rules.requiredS('请填写起始时间'), durationError(newRule.startDatetime, newRule.endDatetime)]"
                label="起始时间*"
                v-model="newRule.startDatetime"
                :disabled="hasAreaLimitConfig && noGatewaysSelected"
                :hint="hasAreaLimitConfig && noGatewaysSelected ? '请先选择允许通行关口' : ''"
                :persistent-hint="hasAreaLimitConfig && noGatewaysSelected"
              ></l-select-datetime>
            </v-flex>

            <v-flex lg6 md6 xs12>
              <l-select-datetime
                :disabled="!newRule.startDatetime || (hasAreaLimitConfig && noGatewaysSelected) || shouldDisableEndTime"
                :max-date="maxDurationDate"
                :min-date="startDate"
                :rules="[$rules.requiredS('请填写终止时间')]"
                label="终止时间*"
                v-model="newRule.endDatetime"
                :hint="hasAreaLimitConfig && noGatewaysSelected ? '请先选择允许通行关口' : (shouldDisableEndTime ? `基于所选区域限制，终止时间自动设置为起始时间+${activeDuration}小时` : '')"
                :persistent-hint="hasAreaLimitConfig && (noGatewaysSelected || shouldDisableEndTime)"
                :readonly="shouldDisableEndTime"
              ></l-select-datetime>
            </v-flex>
          </v-layout>

          <!--<v-divider></v-divider>-->
          <!--循环-->
          <v-subheader class="px-0" v-if="isPeriod">循环时段配置</v-subheader>
          <!--<h3>{{panel}}</h3>-->
          <v-layout justify-space-around row v-if="isPeriod" wrap>
            <v-flex xs12>
              <v-divider></v-divider>
              <v-expansion-panel
                class="flat"
                expand
                v-model="panel"
              >

                <v-expansion-panel-content :key="slice.index" v-for="(slice, i) in newRule.slices">
                  <div slot="header">
                    <span class="caption grey--text">{{'时间片 '+ (i+1)}}</span>
                    <span class="mx-3"></span>
                    <span class="caption grey--text pr-1">开始时间</span>
                    <span v-if="!isPeriodPerDay">{{ cnLong[slice.startWeekday - 1]}} </span>
                    <span>{{ slice.startTime }}</span>
                    <span class="mx-2"></span>
                    <span class="caption grey--text pr-1">结束时间</span>
                    <span v-if="!isPeriodPerDay">{{cnLong[slice.endWeekday - 1]}} </span>
                    <span>{{slice.endTime}}</span>
                    <span class="mx-2"></span>
                  </div>
                  <v-container class="py-0" grid-list-md>
                    <v-layout align-center justify-space-around row v-if="!isPeriodPerDay">
                      <v-flex>
                        <v-layout>
                          <v-flex xs4>
                            <l-select-weekday
                              :rules="[$rules.requiredS('必填'), durationError(slice.startWeekday, slice.endWeekday)]"
                              label="星期*"
                              return-number
                              v-model="slice.startWeekday"
                            ></l-select-weekday>
                          </v-flex>
                          <v-flex xs8>
                            <l-select-time
                              :max="maxSliceTime"
                              :min="minSliceTime"
                              :rules="[$rules.requiredS('必填'), durationError(slice.startTime, slice.endTime)]"
                              hide-icon
                              label="开始时间*"
                              v-model="slice.startTime"
                            ></l-select-time>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <!--<span class="mx-3"> 至 </span>-->
                      <v-flex>
                        <v-layout>
                          <v-flex xs4>
                            <l-select-weekday
                              :rules="[$rules.requiredS('必填')]"
                              label="星期*"
                              return-number
                              v-model="slice.endWeekday"
                            ></l-select-weekday>
                          </v-flex>
                          <v-flex xs8>
                            <l-select-time
                              :max="maxSliceTime"
                              :min="slice.startTime > minSliceTime ? slice.startTime: minSliceTime"
                              :rules="[$rules.requiredS('必填')]" hide-icon
                              label="结束时间*"
                              v-model="slice.endTime"
                            ></l-select-time>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout align-center justify-space-around row v-if="isPeriodPerDay">
                      <v-flex>
                        <v-layout>
                          <v-flex xs12>
                            <l-select-time
                              :max="maxSliceTime"
                              :min="minSliceTime"
                              :rules="[$rules.requiredS('必填'),durationError(slice.startTime, slice.endTime)]"
                              label="开始时间*"
                              v-model="slice.startTime"
                            ></l-select-time>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex>
                        <v-layout>
                          <v-flex xs12>
                            <l-select-time
                              :max="maxSliceTime"
                              :min="slice.startTime > minSliceTime ? slice.startTime: minSliceTime"
                              :rules="[$rules.requiredS('必填')]"
                              label="结束时间*"
                              v-model="slice.endTime"
                            ></l-select-time>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs12>
                        <l-select-controller
                          :required="hadInit"
                          v-model="slice.gateways"
                          :passType="passType"
                        ></l-select-controller>
                      </v-flex>
                    </v-layout>
                    <v-layout class="mb-4" justify-end row>
                      <v-btn :flat="!slice.deleteButtonState"
                             @click="deleteSlice(slice, i)"
                             class="mx-0"
                             color="error"
                      >
                        {{slice.deleteButtonState ? '确认删除':'删除'}}
                      </v-btn>
                    </v-layout>
                  </v-container>
                </v-expansion-panel-content>

              </v-expansion-panel>
              <v-divider></v-divider>
            </v-flex>

            <v-flex class="mb-4" xs12>
              <v-btn @click="addSlice" class="mx-1" color="primary" flat>添加时间片</v-btn>
            </v-flex>

          </v-layout>
          <!--<v-divider v-if="isPeriod"></v-divider>-->

          <!--场区及关口（循环不显示）-->
          <v-subheader class="px-0" v-if="!isPeriod">允许通行关口</v-subheader>
          <v-layout v-if="!isPeriod" column>
            <v-flex xs12 v-if="presetCtrls.length!==0">
              <v-select
                label="园区关口组合选项(可选)"
                :items="presetCtrls"
                item-text="name"
                prepend-icon="$vuetify.icons.car"
                v-model="presetCtrlsSelect"
                chips
                multiple
                clearable
                attach
                ref="selectRef"
                @blur="closeSelectMenu"
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <l-select-controller
                :required="hadInit"
                v-model="newRule.gateways"
                :disabled="authority.name==='个人预约'||authority.name==='单位预约'"
                :passType="passType"
              ></l-select-controller>
            </v-flex>
          </v-layout>
          <v-subheader class="px-0" v-if="canEditPrompt">通行提示</v-subheader>
          <v-layout row v-if="canEditPrompt" wrap>
            <v-flex xs12>
              <v-textarea
                :counter="$rules.ledPromptCount"
                :hint="`${$rules.ledPromptCount}字以内`"
                :rules="[$rules.ledPromptRule]"
                auto-grow
                label="进场屏显提示词"
                prepend-icon="$vuetify.icons.led"
                rows="1"
                v-model="newRule.ledPromptIn"
              ></v-textarea>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                :counter="$rules.audioPromptCount"
                :hint="`${$rules.audioPromptCount}字以内`"
                :rules="[$rules.audioPromptRule]"
                auto-grow
                label="进场语音提示词"
                prepend-icon="$vuetify.icons.audio"
                rows="1"
                v-model="newRule.audioPromptIn"
              ></v-textarea>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                :counter="$rules.ledPromptCount"
                :hint="`${$rules.ledPromptCount}字以内`"
                :rules="[$rules.ledPromptRule]"
                auto-grow
                label="出场屏显提示词"
                prepend-icon="$vuetify.icons.led"
                rows="1"
                v-model="newRule.ledPromptOut"
              ></v-textarea>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                :counter="$rules.audioPromptCount"
                :hint="`${$rules.audioPromptCount}字以内`"
                :rules="[$rules.audioPromptRule]"
                auto-grow
                label="出场语音提示词"
                prepend-icon="$vuetify.icons.audio"
                rows="1"
                v-model="newRule.audioPromptOut"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
      <slot name="after"/>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click.native="cancel" color="grey" flat large>取消</v-btn>
      <v-btn :loading="loading" @click.native="save" color="primary" flat large>保存</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import LSelectController from './LSelectController'
import {PassRule, TimeSlice} from '../object'
import {time} from '@/ladmin/utils'

export default {
  name: 'SetPassRuleContent',
  components: {LSelectController},
  props: {
    authority: {
      type: Object,
      default: () => ({
        type: ['sectional'],
      }),
    },
    rule: {
      type: Object,
      default: () => (new PassRule()),
    },
    prefix: {
      type: String,
      default: '规则'
    },
    params: {
      type: Object,
      default: () => ({
        index: 0,
        type: '',
      }),
    },
    status: {
      type: String,
      default: 'new',
    },
    passType: {
      type: String,
      default: 'vehicle'
    },
    isUnitReservation: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    hadInit: true,
    valid: false,
    cnLong: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
    panel: [],
    extraVa: false,
    loading: false,
    newRule: {},
    presetCtrls: [],
    presetCtrlsSelect: [],
    limitAreaConfigs: [],      // 从接口获取的限制配置
    activeDuration: null,      // 当前激活的时长限制（小时）
    
    // periodType: '按天循环',
    // timeItem: {},
  }),
  computed: {
    parkingLotSelects () {
      let selects = []
      if (this.items instanceof Array) {
        selects = this.items
      }
      else if (this.itemsP instanceof Array) {
        selects = this.itemsP
      }
      else if (this.$store.state.parkingLot.parkingLotList instanceof Array) {
        selects = this.$store.state.parkingLot.parkingLotList.slice()
      }
      if (selects.length === 0) {
        selects.push({header: '没有可选停车场区'})
      }
      return selects
    },
    controllers () {
      let cs = []
      if (this.items instanceof Array) {
        cs = Array.prototype.concat.apply([], this.items.map(t => t.controllers))
      }
      else if (this.itemsC instanceof Array) {
        cs = this.itemsC
      }
      else if ((this.passType === 'vehicle') && this.$store.state.parkingLot.controllerList instanceof Array) {
        cs = this.$store.state.parkingLot.controllerList.slice()
      }
      else if ((this.passType === 'person') && this.$store.state.parkingLot.personControllerList instanceof Array) {
        cs = this.$store.state.parkingLot.personControllerList.slice()
        console.log(cs)
      }
      return cs
    },
    durationError () {
      return (s, e) => {
        return !s || !e || s <= e || '不能大于结束时间'
      }
    },
    startDate () {
      let group = /^\d{4}-\d\d-\d\d/i.exec(this.newRule.startDatetime)
      if (group) {
        let date = group[0]
        return date
      }
      else {
        return undefined
      }
    },
    title () {
      return (this.status === 'edit' ? '编辑' : '添加') + this.prefix
    },
    subtitle () {
      return this.prefix + (this.params.index + 1)
    },
    isPeriod () {
      return this.newRule.ruleType === 'periodic'
    },
    isPeriodPerDay () {
      return this.newRule.period === 'day'
    },
    // controllersGroup () {
    //   return this.$store.state.controllersGroup
    // },
    // parkingLotList () {
    //   return this.$store.state.parkingLotList
    // },
    newItem () {
      return this.status === 'new'
    },
    readonly () {
      return this.status === 'readonly'
    },
    editing () {
      return this.status === 'edit'
    },
    canUsePeriodDay () {
      return this.authority.type.indexOf('day') !== -1
    },
    canUsePeriodWeek () {
      return this.authority.type.indexOf('week') !== -1
    },
    canEditPrompt () {
      return this.authority.editPrompt
    },
    minStartDay () {
      if (this.authority.minStartDay >= 0) {
        return this.authority.minStartDay
      }
      return undefined
    },
    minSliceTime () {
      if (this.authority.hasOwnProperty('minSliceTime')) {
        return this.authority.minSliceTime
      }
      return undefined
    },
    maxSliceTime () {
      if (this.authority.hasOwnProperty('maxSliceTime')) {
        return this.authority.maxSliceTime
      }
      return undefined
    },
    minStartDate () {
      if (this.minStartDay !== undefined) {
        let nd = this.transFormChinaTime();
        nd.setDate(nd.getDate() + this.minStartDay)
        console.log(nd.getTime())
        return this.$L.time.stringify(nd, this.$L.time.D)
      }
      return undefined
    },
    maxStartDay () {
      if (this.authority.maxStartDay >= 0) {
        return this.authority.maxStartDay
      }
      return undefined
    },
    maxStartDate () {
      if (this.maxStartDay !== undefined) {
        let nd = this.transFormChinaTime();
        nd.setDate(nd.getDate() + this.maxStartDay)
        return this.$L.time.stringify(nd, this.$L.time.D)
      }
      return undefined
    },
    maxDurationDay () {
      if (this.authority.maxDurationDay >= 0) {
        return this.authority.maxDurationDay
      }
      return undefined
    },
    maxDurationDate () {
      if (this.maxDurationDay === undefined || !this.newRule.startDatetime) {
        return
      }
      let [year, month, day] = this.startDate.split('-')
      if (year && month && day) {
        // console.log(this.startDate, Number(year), Number(month) - 1, Number(day), this.maxDurationDay)
        let d = new Date(Number(year), Number(month) - 1, Number(day))
        d.setDate(d.getDate() + this.maxDurationDay - 1)
        return this.$L.time.stringify(d, this.$L.time.D)
      }
      return undefined
    },
    noGatewaysSelected () {
      if (!this.newRule.gateways || this.newRule.gateways.length === 0) {
        return true
      }
      return this.newRule.gateways.every(lot => !lot.controllers || lot.controllers.length === 0)
    },
    shouldDisableEndTime() {
      return this.hasAreaLimitConfig && this.activeDuration !== null;
    },
    // 判断是否有区域限制配置
    hasAreaLimitConfig() {
      return this.authority && this.authority.limitAreaConfigs && this.authority.limitAreaConfigs.length > 0;
    }
  },
  watch: {
    'newRule.startDatetime' (val, oldVal) {
      if (val && !oldVal) {
        let time = this.$L.time
        let d = time.parse(val)
        let now = this.transFormChinaTime()
        if (time.stringify(d, time.D) === time.stringify(now, time.D) &&
          time.stringify(d, time.DT) !== time.stringify(now, time.DT)) {
          this.newRule.startDatetime = time.stringify(now, time.DT)
        }
      }
      
      // 对于有区域限制配置的预约，根据activeDuration计算终止时间
      if (this.hasAreaLimitConfig && this.activeDuration !== null && val) {
        this.calculateEndTime();
        return;
      }
      
      if(this.newRule.endDatetime!==''){
        return
      }
      let endDateTime = new Date(this.newRule.startDatetime)
      if (endDateTime.getHours() < 18 || (endDateTime.getHours() === 18 && endDateTime.getMinutes() === 0)) {
        endDateTime.setDate(endDateTime.getDate())
        endDateTime.setHours(endDateTime.getHours() + 3)
        this.newRule.endDatetime = time.stringify(endDateTime).substring(0, 16)
      }
    },
    'newRule.ruleType': {
      handler (val) {
        // console.log('type change')
        if (!(this.newRule.slices instanceof Array)) {
          this.newRule.slices = []
        }
      },
      deep: true,
    },
    presetCtrlsSelect (val, oldVal) {
      // 保存起始时间
      const savedStartDatetime = this.newRule.startDatetime;
      
      this.newRule.gateways = []
      // console.log(this.presetCtrlsSelect)
      let tmpList = []
      for (let i = 0; i < this.presetCtrlsSelect.length; i++) {
        for (let j = 0; j < this.presetCtrls.length; j++) {
          if (this.presetCtrlsSelect[i] === this.presetCtrls[j].name) {
            for (let k = 0; k < this.presetCtrls[j].item.length; k++) {
              var obj = {
                name: this.presetCtrls[j].item[k].name,
                id: this.presetCtrls[j].item[k].id,
                controllers: this.presetCtrls[j].item[k].controllers
              }
              /* this.newRule.gateways = [...this.newRule.gateways, obj] */
              tmpList.push(obj)
            }
          }
        }
      }
      for (let i = 0; i < this.parkingLotSelects.length; i++) {
        let array = tmpList.filter((v) => (
          v.id === this.parkingLotSelects[i].id
        ))
        // console.log(array)
        if (array.length !== 0) {
          let obj = {
            name: this.parkingLotSelects[i].name,
            id: this.parkingLotSelects[i].id,
            controllers: []
          }
          let tmpControllers = []
          for (let j = 0; j < array.length; j++) {
            for (let k = 0; k < array[j].controllers.length; k++) {
              tmpControllers.push(array[j].controllers[k])
            }
          }
          obj.controllers = tmpControllers
          this.newRule.gateways = [...this.newRule.gateways, obj]
        }
      }
      
      // 有区域限制配置的预约场景下，检查controllerIds是否匹配限制区域
      if (this.hasAreaLimitConfig) {
        // 延迟执行，确保gateways已更新完成
        this.$nextTick(() => {
          this.checkAreaLimit();
          
          // 如果起始时间已设置，且有活跃限制，重新计算终止时间
          if (savedStartDatetime && this.activeDuration !== null) {
            this.calculateEndTime();
          }
        });
      }
    }
  },
  methods: {

         // 添加关闭下拉菜单的方法
         closeSelectMenu() {
      if (this.$refs.selectRef) {
        // 如果是数组，处理每个引用
        if (Array.isArray(this.$refs.selectRef)) {
          this.$refs.selectRef.forEach(ref => {
            if (ref && typeof ref.blur === 'function') {
              ref.blur()
            }
          })
        } 
        // 单个引用情况
        else if (typeof this.$refs.selectRef.blur === 'function') {
          this.$refs.selectRef.blur()
        }
      }
    },
    // 检查选中的controllerIds是否匹配限制区域
    checkAreaLimit() {
      // 重置活跃限制
      this.activeDuration = null;
      
      // 如果没有limitAreaConfigs，尝试从authority获取
      if (!this.limitAreaConfigs || this.limitAreaConfigs.length === 0) {
        if (this.authority && this.authority.limitAreaConfigs) {
          this.limitAreaConfigs = this.authority.limitAreaConfigs;
        } else {
          return;
        }
      }
      
      // 收集所有选中的controllerIds
      const selectedControllerIds = [];
      for (let i = 0; i < this.newRule.gateways.length; i++) {
        const gateway = this.newRule.gateways[i];
        if (gateway.controllers && gateway.controllers.length > 0) {
          for (let j = 0; j < gateway.controllers.length; j++) {
            selectedControllerIds.push(gateway.controllers[j].id);
          }
        }
      }
      
      if (selectedControllerIds.length === 0) {
        return;
      }
      
      // 检查是否匹配任何限制区域
      for (let i = 0; i < this.limitAreaConfigs.length; i++) {
        const config = this.limitAreaConfigs[i];
        
        // 根据预约类型选择不同的匹配逻辑
        let isMatched = false;
        
        if (this.authority.name === '个人预约') {
          // 个人预约：部分匹配（任选一个区域就触发）
          for (let j = 0; j < config.controllerIds.length; j++) {
            if (selectedControllerIds.includes(config.controllerIds[j])) {
              isMatched = true;
              break;
            }
          }
        } else {
          // 单位预约：完全匹配（必须包含限制区域的所有controllerIds）
          let containsAll = true;
          for (let j = 0; j < config.controllerIds.length; j++) {
            if (!selectedControllerIds.includes(config.controllerIds[j])) {
              containsAll = false;
              break;
            }
          }
          isMatched = containsAll;
        }
        
        if (isMatched && config.duration) {
          // 如果找到匹配的配置，使用最短的持续时间
          if (this.activeDuration === null || config.duration < this.activeDuration) {
            this.activeDuration = config.duration;
          }
        }
      }
    },
    
    // 计算终止时间
    calculateEndTime() {
      if (this.activeDuration === null || !this.newRule.startDatetime) {
        return;
      }
      
      const time = this.$L.time;
      const startDate = new Date(this.newRule.startDatetime);
      const endDate = new Date(startDate.getTime());
      
      // 添加限制的duration（小时）到起始时间
      endDate.setHours(endDate.getHours() + this.activeDuration);
      
      // 更新终止时间
      this.newRule.endDatetime = time.stringify(endDate).substring(0, 16);
    },
    
    transFormChinaTime(){
      var d=new Date();
     /* var localTime = d.getTime();
      var localOffset=d.getTimezoneOffset()*60000;
      var utc = localTime + localOffset;
      var offset =8;
      var china= utc + (3600000*offset);
      var nd = new Date(china);*/
      return d
    },
    dealPresetCtrls (data) {
      for (let k = 0; k < data.length; k++) {
        var name = data[k].name
        var controllers = []
        var items = []
        for (let i = 0; i < data[k].controllerIds.length; i++) {
          for (let j = 0; j < this.controllers.length; j++) {
            if (this.controllers[j].id === data[k].controllerIds[i]) {
              controllers.push(this.controllers[j])
            }
          }
        }
        for (let i = 0; i < this.parkingLotSelects.length; i++) {
          var item = {
            name: this.parkingLotSelects[i].name,
            id: this.parkingLotSelects[i].id,
            controllers: []
          }
          for (let j = 0; j < controllers.length; j++) {
            if (controllers[j].parkingLot.id === this.parkingLotSelects[i].id) {
              item.controllers.push(controllers[j])
            }
          }
          if (item.controllers.length !== 0) {
            items.push(item)
          }
        }
        var config = {
          name: name,
          controllers: controllers,
          item: items
        }
        this.presetCtrls.push(config)
      }
      this.presetCtrls.sort(function (a,b) {
        if(a.name===b.nam){
          return 0;
        }else if(a.name>b.name){
          return 1
        }else{
          return -1
        }
      })
      console.log(this.presetCtrls)
    },
    stopLoading () {
      this.loading = false
    },
    addSlice () {
      this.newRule.slices.push(new TimeSlice(this.newRule.slices.length))
      // this.panel.push(false)
      let l = this.newRule.slices.length
      setTimeout(() => {
        this.$set(this.panel, l - 1, true)
        // console.log('toggle', l)
      }, 50)
    },
    deleteSlice (s, i) {
      if (s.deleteButtonState) {
        if (i !== -1) {
          this.$set(this.panel, i, false)
          setTimeout(() => {
            this.newRule.slices.splice(i, 1)
          }, 100)
        }
      }
      else {
        console.log('set Button')
        this.$set(s, 'deleteButtonState', true)
        setTimeout(() => {
          this.$set(s, 'deleteButtonState', false)
        }, 1200)
      }
    },
    cancel () {
      this.$emit('cancel')
    },
    save () {
      // console.log(this.newRule)
      this.extraVa = true
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$emit('save', {status: this.status, newItem: this.newRule, oldItem: this.rule})
      }
      else {
        console.log(this.valid)
      }
    },
  },
  created () {
    // 如果有区域限制配置，从authority中获取limitAreaConfigs
    if (this.hasAreaLimitConfig) {
      this.limitAreaConfigs = this.authority.limitAreaConfigs;
    }
    
    if (this.status === 'edit' || this.status === 'readonly') {
      this.newRule = new this.rule.constructor(this.rule)
      if (this.newRule.period === 'day' || this.newRule.period === 'week') {
      }
      else {
        this.newRule.period = 'day'
      }
      if (this.newRule.ruleType === 'periodic') {
        for (let i = 0; i < this.newRule.slices.length; ++i) {
          this.panel.push(false)
        }
      }
    }
    else if (this.status === 'new') {
      this.newRule = new this.rule.constructor(this.params.index)
      if (this.canUsePeriodWeek && !this.canUsePeriodDay) {
        this.newRule.period = 'week'
      }
      this.newRule.groupId = ""
      let config = this.$store.state.reservation ? this.$store.state.reservation.globalConfig || {} : {}
      this.newRule.audioPromptIn = config.audioPromptIn || ''
      this.newRule.ledPromptIn = config.ledPromptIn || ''
      this.newRule.audioPromptOut = config.audioPromptOut || ''
      this.newRule.ledPromptOut = config.ledPromptOut || ''
    }
    this.dealPresetCtrls(this.authority.presetCtrls)
    console.log(this.newRule)
    console.log('set passing rule', this.newRule.gateways[0] === this.rule.gateways[0], this.newRule === this.rule)
    
    // 初始化完成后，如果已有选中的预设区域和关口，检查限制区域
    this.$nextTick(() => {
      if (this.hasAreaLimitConfig && this.newRule.gateways && this.newRule.gateways.length > 0) {
        this.checkAreaLimit();
        
        // 如果已有起始时间和活跃限制，计算终止时间
        if (this.newRule.startDatetime && this.activeDuration !== null) {
          this.calculateEndTime();
        }
      }
    });
  },
  mounted () {
    this.$refs.form.resetValidation()
  }
}
</script>

<style scoped>
  .flat {
    box-shadow: none !important;
  }
</style>
